import { RoutePath } from "./routePath";

/**
 * Path constants for account management.
 * Covers profile, documents, security settings, and policy reinstatement.
 */
export const RouteTemplates = {
  document: "/account/document/:id",
  policyReinstatementDetails: "/account/policy-reinstatement/:policyId",
} as const;

export const accountPaths = {
  root: "/account",
  changePassword: "/account/change-password",
  document: RoutePath(RouteTemplates.document),
  documents: "/account/documents",
  profileEdit: "/account/profile/edit",
  profile: "/account/profile",
  policyReinstatement: "/account/policy-reinstatement",
  policyReinstatementDetails: RoutePath(RouteTemplates.policyReinstatementDetails),
};
